export const filterInt = value => (/^(-|\+)?([0-9]+|Infinity)$/.test(value) ? Number(value) : NaN);
